import {useCallback, useEffect, useState} from "react";
import {findUserThematics} from "../api/userThematicApiClient";

export const useUserThematics = (userId, reloadTrigger) => {
    const [userThematics, setUserThematics] = useState([]);
    const [loading, setLoading] = useState(true);

    const reload = useCallback((signal = null) => {
        setLoading(true);

        return findUserThematics(userId, signal)
            .then((data) => {
                setUserThematics(data);
                return data;
            })
            .finally(() => setLoading(false));
    }, [userId]);

    useEffect(() => {
        const abortController = new AbortController();

        reload(abortController.signal)
            .catch(
                (error) => {
                    if (error.name === "AbortError") {
                        console.log("Aborted");
                    }
                    else {
                        console.log(error);
                    }
                }
            );

        return () => {
            abortController.abort();
        };
    }, [reload, reloadTrigger]);

    return {userThematics, loading, reload};
};
